import type { OAuthProvider } from '~/common/auth/providers'
import { config } from '~/common/config/config'

/**
 * Auth route types for WorkOS endpoints.
 * ARP uses WorkOS exclusively (no Firebase).
 */
export type AuthRoute =
  | 'sign-in'
  | 'check-session'
  | 'sign-out'
  | 'reset-password'
  | 'confirm-reset-password'
  | 'accept-invitation'
  | 'magic-auth/send-code'
  | 'magic-auth/verify-code'

/**
 * Get the full URL for a WorkOS auth endpoint.
 * All auth routes in ARP go through WorkOS.
 */
export const getAuthRoute = (route: AuthRoute): string => {
  return `${config.apiUrl}/unauthenticated/auth/workos/${route}`
}

/**
 * Get the OAuth authorization URL endpoint for a provider.
 */
export const getOAuthUrl = (provider: OAuthProvider): string => {
  return `${config.apiUrl}/unauthenticated/auth/oauth/${provider}/url`
}
